module.exports = __webpack_public_path__ + "img/Remote-Ventures.085478b6.png";